module.exports = __webpack_public_path__ + "img/12.faa7c196.svg";